<template>
<transition name="modal">
<div id="mirrorMenuModal" class="mirrorMenuModal">
  <div class="mirrorMenuModal__wrap">
    <div class="mirrorMenuModal__wrap__title">阪急うめだ本店<br /><span>My Custom Bag Studio</span></div>
    <ul class="mirrorMenuModal__wrap__links">
      <li><router-link to="/mirror" exact>HOME<br /><span>スマートミラーのホーム画面に戻ります</span></router-link></li>
      <!-- <li><router-link to="/mirror/qrcode" exact>QRコード読取<br /><span>お客様のQRコードを読み取り、スマートミラーで編集します</span></router-link></li> -->
      <li><router-link to="/mirror/customid" exact>カスタム商品連携<br /><span>お客様のカスタム商品を読み取り、スマートミラーで編集します</span></router-link></li>
      <li><router-link to="/mirror/mode" exact>ミラーを表示する<br /><span>通常の鏡として表示します</span></router-link></li>
    </ul>
  </div>
  <div @click="$emit('closeMenu')" class="mirrorMenuModal__closebtn">
    <img src="@/assets/images/mirror/commons/commons-close.svg" alt="Close">
  </div>
</div>
</transition>
</template>

<script>
export default {
  props: {
    customID: String
  }
}
</script>

<style lang="scss" scoped>
.mirrorMenuModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  transition: all .3s ease;
  background: rgba(#111, 0.9);
  line-height: 1.5;
  &__wrap {
    width: 700px;
    position: absolute;
    top: 25%;
    left: 50%;
    margin-left: -350px;
    &__title {
      text-align: left;
      color: $base-white;
      font-size: 50px;
      font-weight: bold;
      line-height: 1.0;
      span {
        font-weight: normal;
        font-size: 30px;
      }
    }
    &__links {
      color: $base-white;
      margin-top: 80px;
      border-top: 3px solid rgba($base-white, 0.3);
      li {
        border-bottom: 3px solid rgba($base-white, 0.3);
        font-size: 36px;
        font-weight: bold;
        position: relative;
        span {
          font-size: 18px;
          font-weight: normal;
        }
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          right: 0;
          width: 40px;
          height: 40px;
          background: url('../../assets/images/mirror/commons/commons-menuArrow.svg') top left no-repeat;
          background-size: 40px 40px;
          margin-top: -20px;
        }
      }
      a {
        display: block;
        color: $base-white;
        padding: 25px 0;
        &.router-link-exact-active {
          color: $dark-gray;
        }
      }
    }
  }
  &__closebtn {
    @include mirrorMenuBtn;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mirror/MirrorMenuModal.vue